/*
  ml-attr-promo — what the campaign modal (assets/ml-campaign-modal.js) needs to know about
  this visitor, captured on every page (Pass 3 Capture Modals, G2 "which product"):

  1. promo_product from the ad URL (?promo_product=magnesium-glycinate) is written into the
     monthlees_attr_v1 record next to the UTMs (assets/monthlees-attribution.js owns that
     record and its 30-day expiry), with promo_product_at so the modal can honour it for
     only its own TTL (7 days by default). A later ad click with a different product wins.
     If the record can't be read (storage blocked), a standalone ml_promo_product entry
     is kept instead.
  2. The last product viewed this session (sessionStorage ml_last_viewed) and the number of
     product pages viewed this session (ml_pv_count), from the data attributes the
     ml-campaign-modal snippet prints on product pages.
  3. Whether the visitor added to cart this session (ml_atc), which the touch triggers
     need ("without an add to cart").

  Nothing here is sent anywhere; it only reads the URL and writes browser storage.
*/
(function () {
  'use strict';
  if (window.__mlAttrPromo) return;
  window.__mlAttrPromo = true;

  var KEY = 'monthlees_attr_v1';

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }

  // 1. promo_product
  var promo = null;
  try {
    promo = new URLSearchParams(window.location.search || '').get('promo_product');
  } catch (e) {}
  if (promo) {
    promo = String(promo).toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 120);
  }
  if (promo) {
    var stamp = new Date().toISOString();
    var saved = false;
    try {
      var rec = JSON.parse(ls(KEY) || 'null');
      if (rec && typeof rec === 'object') {
        rec.promo_product = promo;
        rec.promo_product_at = stamp;
        ls(KEY, JSON.stringify(rec));
        saved = true;
      }
    } catch (e) {}
    if (!saved) ls('ml_promo_product', JSON.stringify({ promo_product: promo, promo_product_at: stamp }));
  }

  // 2. last viewed + product views this session
  var marker = document.querySelector('[data-ml-cm-product-handle]');
  var handle = marker && marker.getAttribute('data-ml-cm-product-handle');
  if (handle) {
    var last = ss('ml_last_viewed');
    if (last !== handle) {
      ss('ml_pv_count', String((parseInt(ss('ml_pv_count'), 10) || 0) + 1));
    }
    ss('ml_last_viewed', handle);
  }

  // 3. add to cart this session
  function markAtc() {
    ss('ml_atc', '1');
  }
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) markAtc();
    },
    true
  );
  document.addEventListener('monthlees:cart-updated', function (e) {
    if (e.detail && e.detail.source === 'ml-cart-v2') markAtc();
  });
  if (typeof window.fetch === 'function') {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) markAtc();
      } catch (e) {}
      return orig.apply(this, arguments);
    };
  }
})();
